import React, { useState } from "react";
import Calendar from "./elements/calendar/Calendar";
import "./elements/calendar/Calendar.css";

function Eventos() {
  const [createRequest, setCreateRequest] = useState(0);

  const handleCreateNew = () => setCreateRequest((v) => v + 1);

  return (
    <div id="events-container">
      <div className="events-actions">
        <div className="events-actions-spacer" />
        <button
          type="button"
          className="events-action-btn"
          aria-label="Agregar nuevo evento"
          title="Agregar nuevo evento"
          onClick={handleCreateNew}
        >
          +
        </button>
      </div>
      <Calendar createRequest={createRequest} />
      {/* Additional event-related components can be added here */}
    </div>
  );
}
export default Eventos;
